import { PayloadAction, createSlice } from '@reduxjs/toolkit';
import { InititalState } from './types';
import {
  getCmpMailboxes,
  getCmpSequences,
  getConnectedCmpList,
  getInstantlySequences,
} from './run-campaign.action';

const initialState: InititalState = {
  connectedCmpList: [],
  connectedCmpListLoading: true,
  mailboxes: [],
  mailboxesLoading: false,
  cmpSequences: [],
  cmpSequencesLoading: false,
  cmpProviderName: '',
};

const runCampaignSlice = createSlice({
  name: 'run-campaign',
  initialState,
  reducers: {
    setCmpProviderName: (state, { payload }: PayloadAction<string>) => {
      state.cmpProviderName = payload;
    },
    clearCmpSequences: (state) => {
      state.cmpSequences = [];
    },
  },
  extraReducers: (builder) => {
    // get connected campaigns list
    builder.addCase(getConnectedCmpList.pending, (state) => {
      state.connectedCmpListLoading = true;
    });
    builder.addCase(getConnectedCmpList.fulfilled, (state, { payload }) => {
      state.connectedCmpList = payload?.filter((i) => i !== 'SPROUTS_CMP') || [];
      state.connectedCmpListLoading = false;
    });
    builder.addCase(getConnectedCmpList.rejected, (state) => {
      state.connectedCmpListLoading = false;
    });

    // get cmp mailboxes
    builder.addCase(getCmpMailboxes.pending, (state) => {
      state.mailboxesLoading = true;
    });
    builder.addCase(getCmpMailboxes.fulfilled, (state, { payload }) => {
      state.mailboxes = payload;
      state.mailboxesLoading = false;
    });
    builder.addCase(getCmpMailboxes.rejected, (state) => {
      state.mailboxesLoading = false;
    });

    // get cmp sequences
    builder.addCase(getCmpSequences.pending, (state) => {
      state.cmpSequencesLoading = true;
    });
    builder.addCase(getCmpSequences.fulfilled, (state, { payload }) => {
      state.cmpSequences = payload;
      state.cmpSequencesLoading = false;
    });
    builder.addCase(getCmpSequences.rejected, (state) => {
      state.cmpSequencesLoading = false;
    });

    // get instantly sequences (search-based)
    builder.addCase(getInstantlySequences.pending, (state) => {
      state.cmpSequencesLoading = true;
    });
    builder.addCase(getInstantlySequences.fulfilled, (state, { payload }) => {
      state.cmpSequences = payload;
      state.cmpSequencesLoading = false;
    });
    builder.addCase(getInstantlySequences.rejected, (state) => {
      state.cmpSequencesLoading = false;
    });
  },
});
export const { setCmpProviderName, clearCmpSequences } = runCampaignSlice.actions;

export default runCampaignSlice.reducer;
